<div class="login" data-testid="login-page">
    <mat-card class="mat-card-container">
        <div class="content-wrapper">
            <div class="image-container">
                <img class="image-404" src="/img/LOGO.png" alt="Logo ACIN" />
            </div>
            <div class="form-container">
                <div class="title-color">
                    <h1>INICIO DE SESIÓN</h1>
                </div>
                <br />

                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Usuario</mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="username"
                            data-testid="login-username"
                            minlength="4"
                        />
                        <mat-error
                            *ngIf="
                                loginForm.get('username')?.hasError('required')
                            "
                        >
                            Campo obligatorio
                        </mat-error>
                        <mat-error
                            *ngIf="
                                loginForm.get('username')?.hasError('minlength')
                            "
                        >
                            El usuario debe tener mínimo 4 caracteres
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="field">
                        <mat-label>Password</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="password"
                            data-testid="login-password"
                            minlength="4"
                            placeholder="********"
                        />
                        <mat-error
                            *ngIf="
                                loginForm.get('password')?.hasError('required')
                            "
                        >
                            Campo obligatorio
                        </mat-error>
                        <mat-error
                            *ngIf="
                                loginForm.get('password')?.hasError('minlength')
                            "
                        >
                            La contraseña debe tener mínimo 4 caracteres
                        </mat-error>
                    </mat-form-field>
                    <div>
                        <button
                            type="submit"
                            class="primary-button"
                            data-testid="login-submit"
                            [disabled]="!loginForm.valid"
                        >
                            Iniciar sesión
                        </button>
                    </div>
                </form>
                <div class="google-signin-container">
                    <div #googleButton></div>
                </div>
                <mat-error
                    class="invalid-form error-message"
                    data-testid="login-error"
                    role="alert"
                    *ngIf="errorMsg"
                >
                    {{ errorMsg }}
                </mat-error>
            </div>
        </div>
    </mat-card>
</div>
